// @flow
import AudioRecorderActionTypes from '../action-types/audio-recorder';
import { RecordingContext } from '../types/audio-recorder';

export const resetAudioRecorderState = () => ({
  type: AudioRecorderActionTypes.RESET_AUDIO_RECORDER_STATE,
});

export const resetRecordingContext = () => ({
  type: AudioRecorderActionTypes.RESET_RECORDING_CONTEXT,
});

export const setHasMicrophoneRestarted = (hasMicrophoneRestarted: boolean) => ({
  type: AudioRecorderActionTypes.SET_HAS_MICROPHONE_RESTARTED,
  payload: hasMicrophoneRestarted,
});

export const setIsRestartingMicrophone = (isRestartingMicrophone: boolean) => ({
  type: AudioRecorderActionTypes.SET_IS_RESTARTING_MICROPHONE,
  payload: isRestartingMicrophone,
});

export const setRecordingContext = (recordingContext: RecordingContext) => ({
  type: AudioRecorderActionTypes.SET_RECORDING_CONTEXT,
  payload: recordingContext,
});
